module.exports = __webpack_public_path__ + "img/mine-bg.86d39445.png";